import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=1d8b1e08&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=1d8b1e08&scoped=true&lang=scss&"
import style1 from "./DefaultLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b1e08",
  null
  
)

export default component.exports